import { render, staticRenderFns } from "./SampleIdentificationInput.vue?vue&type=template&id=02ac6b79&scoped=true"
import script from "./SampleIdentificationInput.vue?vue&type=script&lang=ts"
export * from "./SampleIdentificationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ac6b79",
  null
  
)

export default component.exports